import { CircularProgress } from '@mui/material'
import Button from '@mui/material/Button'
import clsx from 'clsx'
import React from 'react'

import { UButtonProps } from './type'

export const UButton = ({
  variant = 'outlined',
  color = 'secondary',
  isLoading,
  className,
  disabled,
  ...props
}: UButtonProps) => {
  return (
    <Button
      disabled={disabled || isLoading}
      variant={variant}
      color={color}
      {...props}
      className={clsx(isLoading && 'button-loading', className)}
    >
      {isLoading ? (
        <CircularProgress color="inherit" size={20} />
      ) : (
        props.children
      )}
    </Button>
  )
}
